/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CalculateIcon from "@mui/icons-material/Calculate";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import {
  getCristalesValor,
  saveCristalValor,
} from "../../services/CristalValorService";
import { getCrListasPrecios } from "../../services/CrListaPrecioService";
import { getCacheData } from "../../services/CacheService";
import { getConfiguracion } from "../../services/ConfiguracionService";
import ValorCristalDialog from "./ValorCristalDialog";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatMoney } from "../../utils/utils";

const initialValoresData = {
  listaDeReferencia: "todos",
  costoRealDesde: 0,
  costoRealHasta: 0,
  fechaCostoRealDesde: null,
  fechaCostoRealHasta: null,
  tipo: "",
  porcentaje: "",
  monto: "",
  idProveedor: "",
  idCristalProducto: "",
  idBlCrDiametro: "",
  idBlCrAdicionDesde: "",
  idBlCrAdicionHasta: "",
  esferaDesde: "",
  esferaHasta: "",
  cilindroDesde: "",
  cilindroHasta: "",
  // creo las variables para Costo Actual
  idCostoPorcentaje: "",
  costoPorcentajeValor: 0,
  idCostoMonto: "",
  costoMontoValor: 0,
  costoValorFijarPeso: 0,
  costoValorFijarDolar: 0,
  costoValorFijarDescuento: 0,
  // creo las variables para Factor de utilidad
  // contado
  tipoFactorContado: "",
  idFactorContadoPorcentaje: "",
  factorContadoPorcentajeValor: 0,
  idFactorContadoMonto: "",
  factorContadoMontoValor: 0,
  factorContadoValorFijarPeso: 0,
  // lista
  tipoFactorLista: "",
  idFactorListaPorcentaje: "",
  factorListaPorcentajeValor: 0,
  idFactorListaMonto: "",
  factorListaMontoValor: 0,
  factorListaValorFijarPeso: 0,
  // creo las variables para Precio de Venta
  // contado
  tipoPrecioVentaContado: "",
  idPrecioVentaContadoPorcentaje: "",
  precioVentaContadoPorcentajeValor: 0,
  idPrecioVentaContadoMonto: "",
  precioVentaContadoMontoValor: 0,
  precioVentaContadoValorFijarPeso: 0,
  // lista
  tipoPrecioVentaLista: "",
  idPrecioVentaListaPorcentaje: "",
  precioVentaListaPorcentajeValor: 0,
  idPrecioVentaListaMonto: "",
  precioVentaListaMontoValor: 0,
  precioVentaListaValorFijarPeso: 0,
};

const sumaRestaOptions = [
  { id: "suma", descripcion: "Suma" },
  { id: "resta", descripcion: "Resta" },
];

const listaDeReferenciaOptions = [
  {
    id: "todos",
    descripcion: "Todas",
  },
  {
    id: "solo-referencia",
    descripcion: "Sólo las listas que son de referencia",
  },
  {
    id: "solo-no-referencia",
    descripcion: "Sólo las listas que No son de referencia",
  },
];

const initialObject = { id: "", descripcion: "" };
const nameItemsText = "Actualización de Lista de Precio de Cristales";
//
// #############################################################################
//
const ValorCristalTable = () => {
  const [valoresData, setValoresData] = useState(initialValoresData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rangos, setRangos] = useState([]);
  const [rangosCambiar, setRangosCambiar] = useState([]);
  const [rangoData, setRangoData] = useState({});
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [tipoRadioState, setTipoRadioState] = useState("");
  const [tipoFactorContadoRadioState, setTipoFactorContadoRadioState] =
    useState("");
  const [tipoFactorListaRadioState, setTipoFactorListaRadioState] =
    useState("");
  const [
    tipoPrecioVentaContadoRadioState,
    setTipoPrecioVentaContadoRadioState,
  ] = useState("");
  const [tipoPrecioVentaListaRadioState, setTipoPrecioVentaListaRadioState] =
    useState("");
  const [tabActive, setTabActive] = useState(false);
  const [tabOptionsActive, setTabOptionsActive] = useState(false);
  const [valueACCostoPorcentaje, setValueACCostoPorcentaje] =
    useState(initialObject);
  const [inputValueACCostoPorcentaje, setInputValueACCostoPorcentaje] =
    useState("");
  const [valueACCostoMonto, setvalueACCostoMonto] = useState(initialObject);
  const [inputValueACCostoMonto, setInputValueACCostoMonto] = useState("");
  const [valueACFactorContadoPorcentaje, setValueACFactorContadoPorcentaje] =
    useState(initialObject);
  const [
    inputValueACFactorContadoPorcentaje,
    setInputValueACFactorContadoPorcentaje,
  ] = useState("");
  const [valueACFactorContadoMonto, setValueACFactorContadoMonto] =
    useState(initialObject);
  const [inputValueACFactorContadoMonto, setInputValueACFactorContadoMonto] =
    useState("");
  const [valueACFactorListaPorcentaje, setValueACFactorListaPorcentaje] =
    useState(initialObject);
  const [
    inputValueACFactorListaPorcentaje,
    setInputValueACFactorListaPorcentaje,
  ] = useState("");
  const [valueACFactorListaMonto, setValueACFactorListaMonto] =
    useState(initialObject);
  const [inputValueACFactorListaMonto, setInputValueACFactorListaMonto] =
    useState("");
  const [
    valueACPrecioVentaContadoPorcentaje,
    setValueACPrecioVentaContadoPorcentaje,
  ] = useState(initialObject);
  const [
    inputValueACPrecioVentaContadoPorcentaje,
    setInputValueACPrecioVentaContadoPorcentaje,
  ] = useState("");
  const [valueACPrecioVentaContadoMonto, setValueACPrecioVentaContadoMonto] =
    useState(initialObject);
  const [
    inputValueACPrecioVentaContadoMonto,
    setInputValueACPrecioVentaContadoMonto,
  ] = useState("");
  const [
    valueACPrecioVentaListaPorcentaje,
    setValueACPrecioVentaListaPorcentaje,
  ] = useState(initialObject);
  const [
    inputValueACPrecioVentaListaPorcentaje,
    setInputValueACPrecioVentaListaPorcentaje,
  ] = useState("");
  const [valueACPrecioVentaListaMonto, setValueACPrecioVentaListaMonto] =
    useState(initialObject);
  const [
    inputValueACPrecioVentaListaMonto,
    setInputValueACPrecioVentaListaMonto,
  ] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [disabledAplicarCambios, setDisabledAplicarCambios] = useState(true);
  const [proveedores, setProveedores] = useState([]);
  const [cristalProductos, setCristalProductos] = useState([]);
  const [blCrDiametros, setBlCrDiametros] = useState([]);
  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const [valueACProveedor, setValueACProveedor] = useState(initialObject);
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");
  const [valueACCristalProducto, setValueACCristalProducto] =
    useState(initialObject);
  const [inputValueACCristalProducto, setInputValueACCristalProducto] =
    useState("");
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState(initialObject);
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");
  const [valueACBlCrAdicionDesde, setValueACBlCrAdicionDesde] =
    useState(initialObject);
  const [inputValueACBlCrAdicionDesde, setInputValueACBlCrAdicionDesde] =
    useState("");
  const [valueACBlCrAdicionHasta, setValueACBlCrAdicionHasta] =
    useState(initialObject);
  const [inputValueACBlCrAdicionHasta, setInputValueACBlCrAdicionHasta] =
    useState("");
  const [valueACListaReferencia, setValueACListaReferencia] =
    useState(initialObject);
  const [inputValueACListaReferencia, setInputValueACListaReferencia] =
    useState("");
  const [valorDolar, setValorDolar] = useState(0);

  const tableColumns = [
    {
      field: "descripcion_cristal_producto",
      headerName: "Producto",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return params.row.descripcion_cristal_producto?.toUpperCase() ?? "";
      },
    },
    {
      field: "esfera_desde",
      headerName: "ED",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_desde);
      },
    },
    {
      field: "esfera_hasta",
      headerName: "EH",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_hasta);
      },
    },
    {
      field: "cilindro_desde",
      headerName: "CD",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_desde);
      },
    },
    {
      field: "cilindro_hasta",
      headerName: "CH",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_hasta);
      },
    },
    {
      field: "costo_pesos",
      headerName: "Costo $",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_pesos || 0);
      },
    },
    {
      field: "valor_dolar",
      headerName: "Valor U$S",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.valor_dolar || 0);
      },
    },
    {
      field: "costo_dolares",
      headerName: "Costo en U$S",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_dolares || 0);
      },
    },
    {
      field: "porcentaje_descuento",
      headerName: "% Desc",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.porcentaje_descuento || 0);
      },
    },
    {
      field: "costo_real",
      headerName: "Costo Real",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_real || 0);
      },
    },
    {
      field: "fut_contado",
      headerName: "Fut Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.fut_contado || 0, 4);
      },
    },
    {
      field: "precio_venta_contado",
      headerName: "PVta Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_contado || 0);
      },
    },
    {
      field: "fut_lista",
      headerName: "Fut Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.fut_lista || 0, 4);
      },
    },
    {
      field: "precio_venta_lista",
      headerName: "PVta Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_lista || 0);
      },
    },
    {
      field: "referencia",
      headerName: "Referencia",
      headerAlign: "center",
      align: "center",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.referencia ? "SI" : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="ver">
          <IconButton
            size="small"
            aria-label="view"
            onClick={() => {
              handleClickVerRango(params.row);
            }}
          >
            <RemoveRedEyeOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const handleSelectionModelChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    checkboxSelection: true,
    disableRowSelectionOnClick: false,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    rowSelectionModel: selectedRows,
    onRowSelectionModelChange: handleSelectionModelChange,
    getRowId: (row) => row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setIsDoingSomething(true);
    loadConfiguracion();
    loadProveedores();
    loadCristalProductos();
    loadBlCrDiametros();
    loadBlCrAdiciones();
    setIsDoingSomething(false);
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (expandedAccordion !== null) {
      handleCleanAllOptions();
    }
  }, [expandedAccordion]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoPorcentaje"
    ) {
      setValueACPrecioVentaContadoMonto(initialObject);
      setInputValueACPrecioVentaContadoMonto("");
      valoresData.precioVentaContadoMontoValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoMonto"
    ) {
      setValueACPrecioVentaContadoPorcentaje(initialObject);
      setInputValueACPrecioVentaContadoPorcentaje("");
      valoresData.precioVentaContadoPorcentajeValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoFijarPeso"
    ) {
      setValueACPrecioVentaContadoPorcentaje(initialObject);
      setInputValueACPrecioVentaContadoPorcentaje("");
      setValueACPrecioVentaContadoMonto(initialObject);
      setInputValueACPrecioVentaContadoMonto("");
      valoresData.precioVentaContadoPorcentajeValor = 0;
      valoresData.precioVentaContadoMontoValor = 0;
      valoresData.precioVentaContadoValorFijarPeso = 0;
    }
  }, [tipoPrecioVentaContadoRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaPorcentaje") {
      setValueACPrecioVentaListaMonto(initialObject);
      setInputValueACPrecioVentaListaMonto("");
      valoresData.precioVentaListaMontoValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    } else if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaMonto") {
      setValueACPrecioVentaListaPorcentaje(initialObject);
      setInputValueACPrecioVentaListaPorcentaje("");
      valoresData.precioVentaListaPorcentajeValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    } else if (
      tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaFijarPeso"
    ) {
      setValueACPrecioVentaListaPorcentaje(initialObject);
      setInputValueACPrecioVentaListaPorcentaje("");
      setValueACPrecioVentaListaMonto(initialObject);
      setInputValueACPrecioVentaListaMonto("");
      valoresData.precioVentaListaPorcentajeValor = 0;
      valoresData.precioVentaListaMontoValor = 0;
      valoresData.precioVentaListaValorFijarPeso = 0;
    }
  }, [tipoPrecioVentaListaRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (tipoFactorContadoRadioState === "tipoFactorContadoPorcentaje") {
      setValueACFactorContadoMonto(initialObject);
      setInputValueACFactorContadoMonto("");
      valoresData.factorContadoMontoValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoMonto") {
      setValueACFactorContadoPorcentaje(initialObject);
      setInputValueACFactorContadoPorcentaje("");
      valoresData.factorContadoPorcentajeValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoFijarValor") {
      setValueACFactorContadoPorcentaje(initialObject);
      setInputValueACFactorContadoPorcentaje("");
      setValueACFactorContadoMonto(initialObject);
      setInputValueACFactorContadoMonto("");
      valoresData.factorContadoPorcentajeValor = 0;
      valoresData.factorContadoMontoValor = 0;
      valoresData.factorContadoValorFijarPeso = 0;
    }
  }, [tipoFactorContadoRadioState]);

  // ################################################################################
  //
  useEffect(() => {
    if (tipoFactorListaRadioState === "tipoFactorListaPorcentaje") {
      setValueACFactorListaMonto(initialObject);
      setInputValueACFactorListaMonto("");
      valoresData.factorListaMontoValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    } else if (tipoFactorListaRadioState === "tipoFactorListaMonto") {
      setValueACFactorListaPorcentaje(initialObject);
      setInputValueACFactorListaPorcentaje("");
      valoresData.factorListaPorcentajeValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    } else if (tipoFactorListaRadioState === "tipoFactorListaFijarValorr") {
      setValueACFactorListaPorcentaje(initialObject);
      setInputValueACFactorListaPorcentaje("");
      setValueACFactorListaMonto(initialObject);
      setInputValueACFactorListaMonto("");
      valoresData.factorListaPorcentajeValor = 0;
      valoresData.factorListaMontoValor = 0;
      valoresData.factorListaValorFijarPeso = 0;
    }
  }, [tipoFactorListaRadioState]);
  //
  // ################################################################################
  //
  useEffect(() => {
    let _rangosCambiar = [];
    if (selectedRows.length > 0) {
      _rangosCambiar = rangos.filter((item) => selectedRows.includes(item.id));
    }
    setRangosCambiar(_rangosCambiar);
  }, [selectedRows]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setValoresData({
      ...valoresData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
    if (e.target.type === "radio") {
      if (e.target.name === "tipoFactorContado") {
        setTipoFactorContadoRadioState(e.target.value);
      } else if (e.target.name === "tipoFactorLista") {
        setTipoFactorListaRadioState(e.target.value);
      } else if (e.target.name === "tipoPrecioVentaContado") {
        setTipoPrecioVentaContadoRadioState(e.target.value);
      } else if (e.target.name === "tipoPrecioVentaLista") {
        setTipoPrecioVentaListaRadioState(e.target.value);
      } else {
        setTipoRadioState(e.target.value);
      }
    }
  };
  //
  // ################################################################################
  //
  const handleChangeNumber = (e) => {
    const _numero = e.target.value;
    if (/^\d*\.?\d*$/.test(_numero)) {
      setValoresData({
        ...valoresData,
        [e.target.name]: _numero,
      });
    }
  };
  //
  // ################################################################################
  //
  const handleCleanAllOptions = () => {
    setValoresData({
      ...valoresData,
      idCostoPorcentaje: "",
      costoPorcentajeValor: 0,
      idCostoMonto: "",
      costoMontoValor: 0,
      costoValorFijarPeso: 0,
      costoValorFijarDolar: 0,
      tipoFactorContado: "",
      tipoPrecioVentaContado: "",
      tipoPrecioVentaLista: "",
      idFactorContadoPorcentaje: "",
      factorContadoPorcentajeValor: 0,
      idFactorContadoMonto: "",
      factorContadoMontoValor: 0,
      factorContadoValorFijarPeso: 0,
      tipoFactorLista: "",
      idFactorListaPorcentaje: "",
      factorListaPorcentajeValor: 0,
      idFactorListaMonto: "",
      factorListaMontoValor: 0,
      factorListaValorFijarPeso: 0,
      idPrecioVentaContadoPorcentaje: "",
      precioVentaContadoPorcentajeValor: 0,
      idPrecioVentaContadoMonto: "",
      precioVentaContadoMontoValor: 0,
      precioVentaContadoValorFijarPeso: 0,
      idPrecioVentaListaPorcentaje: "",
      precioVentaListaPorcentajeValor: 0,
      idPrecioVentaListaMonto: "",
      precioVentaListaMontoValor: 0,
      precioVentaListaValorFijarPeso: 0,
      tipo: "",
    });
    setTipoRadioState("");
    setTipoFactorContadoRadioState("");
    setTipoFactorListaRadioState("");
    setTipoPrecioVentaContadoRadioState("");
    setTipoPrecioVentaListaRadioState("");
    setValueACCostoPorcentaje(initialObject);
    setInputValueACCostoPorcentaje("");
    setvalueACCostoMonto(initialObject);
    setInputValueACCostoMonto("");
    setValueACFactorContadoPorcentaje(initialObject);
    setInputValueACFactorContadoPorcentaje("");
    setValueACFactorContadoMonto(initialObject);
    setInputValueACFactorContadoMonto("");
    setValueACFactorListaPorcentaje(initialObject);
    setInputValueACFactorListaPorcentaje("");
    setValueACFactorListaMonto(initialObject);
    setInputValueACFactorListaMonto("");
    setValueACPrecioVentaContadoPorcentaje(initialObject);
    setInputValueACPrecioVentaContadoPorcentaje("");
    setValueACPrecioVentaContadoMonto(initialObject);
    setInputValueACPrecioVentaContadoMonto("");
    setValueACPrecioVentaListaPorcentaje(initialObject);
    setInputValueACPrecioVentaListaPorcentaje("");
    setValueACPrecioVentaListaMonto(initialObject);
    setInputValueACPrecioVentaListaMonto("");
  };
  //
  // ################################################################################
  //
  const handleClearCostoOptions = () => {
    setValoresData({
      ...valoresData,
      idCostoPorcentaje: "",
      costoPorcentajeValor: 0,
      idCostoMonto: "",
      costoMontoValor: 0,
      costoValorFijarPeso: 0,
      costoValorFijarDolar: 0,
      costoDescuentoValor: 0,
    });
    setValueACCostoPorcentaje(initialObject);
    setInputValueACCostoPorcentaje("");
    setvalueACCostoMonto(initialObject);
    setInputValueACCostoMonto("");
  };
  // ################################################################################
  //
  useEffect(() => {
    if (valoresData.tipo !== "costo") {
      handleClearCostoOptions();
    }
  }, [valoresData.tipo]);
  //
  // ################################################################################
  //
  const handleChangeFechaDesde = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaCostoRealDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaHasta = (fecha) => {
    setValoresData({
      ...valoresData,
      fechaCostoRealHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setValoresData(initialValoresData);
    setValueACProveedor(initialObject);
    setInputValueACProveedor("");
    setValueACCristalProducto(initialObject);
    setInputValueACCristalProducto("");
    setValueACBlCrDiametro(initialObject);
    setInputValueACBlCrDiametro("");
    setValueACBlCrAdicionDesde(initialObject);
    setInputValueACBlCrAdicionDesde("");
    setValueACBlCrAdicionHasta(initialObject);
    setInputValueACBlCrAdicionHasta("");
    setValueACListaReferencia({
      id: "todos",
      descripcion: "Todas",
    });
    setInputValueACListaReferencia("");
    setRangos([]);
    setTabActive(false);
    setTabOptionsActive(false);
    setRangosCambiar([]);
    setSelectedRows([]);
    setDisabledAplicarCambios(true);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (valueACProveedor.id === "") {
      setMessage({
        messageText: "Debes seleccionar un Proveedor",
        severity: "error",
      });
      setShowMessage(true);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      idProveedor: valoresData.idProveedor,
      idCristalProducto: valoresData.idCristalProducto,
      idBlCrDiametro: valoresData.idBlCrDiametro,
      idBlCrAdicionDesde: valoresData.idBlCrAdicionDesde,
      idBlCrAdicionHasta: valoresData.idBlCrAdicionHasta,
      esferaDesde: valoresData.esferaDesde,
      esferaHasta: valoresData.esferaHasta,
      cilindroDesde: valoresData.cilindroDesde,
      cilindroHasta: valoresData.cilindroHasta,
      costoRealDesde: valoresData.costoRealDesde,
      costoRealHasta: valoresData.costoRealHasta,
      fechaCostoRealDesde: valoresData.fechaCostoRealDesde,
      fechaCostoRealHasta: valoresData.fechaCostoRealHasta,
      listaDeReferencia: valoresData.listaDeReferencia,
    };

    setIsDoingSomething(true);
    const response = await getCristalesValor(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTabActive(true);
      setTabOptionsActive(true);

      if (response.data.data.length === 0) {
        setRangos([]);
        setMessage({
          messageText: "No hay resultados",
          severity: "warning",
        });
        setShowMessage(true);
        return;
      }

      let _rangos = response.data.data.map((item) => {
        return {
          ...item,
          valor_dolar: valorDolar,
        };
      });

      setRangos(_rangos);
      setTabIndex(1);
    } else {
      setTabActive(false);
      setTabOptionsActive(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadConfiguracion = async () => {
    const response = await getConfiguracion();
    if (response.ok) {
      setValorDolar(response.data.data[0].valor_dolar);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label:
            item.descripcion + (item.contacto ? " - " + item.contacto : ""),
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_var);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrDiametros = async () => {
    const response = await getCacheData("bl_cr_diametro");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor ? item.valor.toString() : "",
        });
      });
      setBlCrDiametros(_var);
    } else {
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickVerRango = (parRango) => {
    let _rango = {};

    const loadRango = async () => {
      setIsDoingSomething(true);
      const response = await getCrListasPrecios({
        idCrLprecioRango: parRango.id_cr_lprecio_rango,
      });
      setIsDoingSomething(false);

      if (response.ok) {
        let _response = response.data.data;
        let _adicionesList = _response.adiciones_list;
        let _adicionesArray = [];
        _adicionesList.forEach((item) => {
          _adicionesArray.push(item.valor_bl_cr_adicion.toFixed(2));
        });

        _rango = {
          id: _response.id,
          descripcionProveedor: _response.descripcion_proveedor,
          descripcionCristalProducto: _response.descripcion_cristal_producto,
          valorBlCrDiametro: _response.valor_bl_cr_diametro,
          adicionDegresion: _adicionesArray.join(", "),
          esferaDesde: _response.esfera_desde.toFixed(2),
          esferaHasta: _response.esfera_hasta.toFixed(2),
          cilindroDesde: _response.cilindro_desde.toFixed(2),
          cilindroHasta: _response.cilindro_hasta.toFixed(2),
          costoPesos: _response.costo_pesos.toFixed(2),
          valorDolar: _response.valor_dolar.toFixed(2),
          costoDolares: _response.costo_dolares.toFixed(2),
          porcentajeDescuento: _response.porcentaje_descuento.toFixed(2),
          costoReal: _response.costo_real.toFixed(2),
          precioVentaContado: _response.precio_venta_contado.toFixed(2),
          futContado: _response.fut_contado.toFixed(4),
          precioVentaLista: _response.precio_venta_lista.toFixed(2),
          futLista: _response.fut_lista.toFixed(4),
        };
        setRangoData(_rango);
        setOpenDialog(true);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
      }
    };
    loadRango();
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  //
  // ##########################################################################
  //
  const calculaCostoActual = () => {
    let _rangosCambiar = rangosCambiar;

    if (valoresData.tipo === "tipoCostoPorcentaje") {
      const _costoPorcentajeValor = parseFloat(
        valoresData.costoPorcentajeValor,
      );

      if (_costoPorcentajeValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACCostoPorcentaje.id === "suma") {
            item.costo_pesos +=
              (item.costo_pesos * _costoPorcentajeValor) / 100;
          } else {
            item.costo_pesos -=
              (item.costo_pesos * _costoPorcentajeValor) / 100;
          }

          if (item.valor_dolar > 0) {
            item.costo_dolares = item.costo_pesos / item.valor_dolar;
          } else {
            item.costo_dolares = 0;
          }

          item.costo_real =
            item.costo_pesos -
            (item.costo_pesos * item.porcentaje_descuento) / 100;

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.costo_real * item.fut_contado * _tasaIva;
          item.precio_venta_lista =
            item.costo_real * item.fut_lista * _tasaIva;
        });
      }
    }

    if (valoresData.tipo === "tipoCostoMonto") {
      const _costoMontoValor = parseFloat(valoresData.costoMontoValor);

      if (_costoMontoValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACCostoMonto.id === "suma") {
            item.costo_pesos += _costoMontoValor;
          } else {
            item.costo_pesos -= _costoMontoValor;
          }

          if (item.valor_dolar > 0) {
            item.costo_dolares = item.costo_pesos / item.valor_dolar;
          } else {
            item.costo_dolares = 0;
          }

          item.costo_real =
            item.costo_pesos -
            (item.costo_pesos * item.porcentaje_descuento) / 100;

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.costo_real * item.fut_contado * _tasaIva;
          item.precio_venta_lista =
            item.costo_real * item.fut_lista * _tasaIva;
        });
      }
    }

    if (valoresData.tipo === "tipoCostoFijarPeso") {
      const _costoValorFijarPeso = parseFloat(valoresData.costoValorFijarPeso);

      _rangosCambiar.forEach((item) => {
        item.costo_pesos = _costoValorFijarPeso;

        if (item.valor_dolar > 0) {
          item.costo_dolares = item.costo_pesos / item.valor_dolar;
        } else {
          item.costo_dolares = 0;
        }

        item.costo_real =
          item.costo_pesos -
          (item.costo_pesos * item.porcentaje_descuento) / 100;

        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado =
          item.costo_real * item.fut_contado * _tasaIva;
        item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
      });
    }

    if (valoresData.tipo === "tipoCostoFijarDolar") {
      const _costoValorFijarDolar = parseFloat(
        valoresData.costoValorFijarDolar,
      );

      _rangosCambiar.forEach((item) => {
        item.costo_dolares = _costoValorFijarDolar;
        item.costo_pesos = _costoValorFijarDolar * item.valor_dolar;

        item.costo_real =
          item.costo_pesos -
          (item.costo_pesos * item.porcentaje_descuento) / 100;

        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado =
          item.costo_real * item.fut_contado * _tasaIva;
        item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
      });
    }

    if (valoresData.tipo === "tipoCostoFijarDescuento") {
      const _costoDescuentoValor = parseFloat(valoresData.costoDescuentoValor);

      _rangosCambiar.forEach((item) => {

        item.porcentaje_descuento = _costoDescuentoValor;

        item.costo_real =
          item.costo_pesos -
          (item.costo_pesos * _costoDescuentoValor) / 100;

        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado =
          item.costo_real * item.fut_contado * _tasaIva;
        item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
      });
    }
  };
  //
  // ##########################################################################
  //
  const calculaFactorUtilidad = () => {
    let _rangosCambiar = rangosCambiar;

    if (tipoFactorContadoRadioState === "tipoFactorContadoPorcentaje") {
      const _factorContadoPorcentajeValor = parseFloat(
        valoresData.factorContadoPorcentajeValor,
      );

      if (_factorContadoPorcentajeValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACFactorContadoPorcentaje.id === "suma") {
            item.fut_contado +=
              (item.fut_contado * _factorContadoPorcentajeValor) / 100;
          } else {
            item.fut_contado -=
              (item.fut_contado * _factorContadoPorcentajeValor) / 100;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.costo_real * item.fut_contado * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoMonto") {
      const _factorContadoMontoValor = parseFloat(
        valoresData.factorContadoMontoValor,
      );

      if (_factorContadoMontoValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACFactorContadoMonto.id === "suma") {
            item.fut_contado += _factorContadoMontoValor;
          } else {
            item.fut_contado -= _factorContadoMontoValor;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_contado =
            item.costo_real * item.fut_contado * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorContadoRadioState === "tipoFactorContadoFijarValor") {
      const _factorContadoValorFijarPeso = parseFloat(
        valoresData.factorContadoValorFijarPeso,
      );

      _rangosCambiar.forEach((item) => {
        item.fut_contado = _factorContadoValorFijarPeso;
        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_contado =
          item.costo_real * item.fut_contado * _tasaIva;
      });
    }

    if (tipoFactorListaRadioState === "tipoFactorListaPorcentaje") {
      const _factorListaPorcentajeValor = parseFloat(
        valoresData.factorListaPorcentajeValor,
      );

      if (_factorListaPorcentajeValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACFactorListaPorcentaje.id === "suma") {
            item.fut_lista +=
              (item.fut_lista * _factorListaPorcentajeValor) / 100;
          } else {
            item.fut_lista -=
              (item.fut_lista * _factorListaPorcentajeValor) / 100;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorListaRadioState === "tipoFactorListaMonto") {
      const _factorListaMontoValor = parseFloat(
        valoresData.factorListaMontoValor,
      );

      if (_factorListaMontoValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACFactorListaMonto.id === "suma") {
            item.fut_lista += _factorListaMontoValor;
          } else {
            item.fut_lista -= _factorListaMontoValor;
          }

          const _tasaIva = 1 + item.tasa_iva / 100;
          item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
          item.cambio = true;
        });
      }
    } else if (tipoFactorListaRadioState === "tipoFactorListaFijarValor") {
      const _factorListaValorFijarPeso = parseFloat(
        valoresData.factorListaValorFijarPeso,
      );

      _rangosCambiar.forEach((item) => {
        item.fut_lista = _factorListaValorFijarPeso;
        const _tasaIva = 1 + item.tasa_iva / 100;
        item.precio_venta_lista = item.costo_real * item.fut_lista * _tasaIva;
      });
    }
  };
  //
  // ##########################################################################
  //
  const calculaPrecioVenta = () => {
    let _rangosCambiar = rangosCambiar;

    if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoPorcentaje"
    ) {
      const _precioVentaContadoPorcentajeValor = parseFloat(
        valoresData.precioVentaContadoPorcentajeValor,
      );

      if (_precioVentaContadoPorcentajeValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACPrecioVentaContadoPorcentaje.id === "suma") {
            item.precio_venta_contado +=
              (item.precio_venta_contado * _precioVentaContadoPorcentajeValor) /
              100;
          } else {
            item.precio_venta_contado -=
              (item.precio_venta_contado * _precioVentaContadoPorcentajeValor) /
              100;
          }

          if (item.costo_real > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_contado =
              item.precio_venta_contado / _tasaIva / item.costo_real;
          } else {
            item.fut_contado = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoMonto"
    ) {
      const _precioVentaContadoMontoValor = parseFloat(
        valoresData.precioVentaContadoMontoValor,
      );

      if (_precioVentaContadoMontoValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACPrecioVentaContadoMonto.id === "suma") {
            item.precio_venta_contado += _precioVentaContadoMontoValor;
          } else {
            item.precio_venta_contado -= _precioVentaContadoMontoValor;
          }

          if (item.costo_real > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_contado =
              item.precio_venta_contado / _tasaIva / item.costo_real;
          } else {
            item.fut_contado = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaContadoRadioState === "tipoPrecioVentaContadoFijarPeso"
    ) {
      const _precioVentaContadoValorFijarPeso = parseFloat(
        valoresData.precioVentaContadoValorFijarPeso,
      );

      _rangosCambiar.forEach((item) => {
        item.precio_venta_contado = _precioVentaContadoValorFijarPeso;

        if (item.costo_real > 0) {
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.fut_contado =
            item.precio_venta_contado / _tasaIva / item.costo_real;
        } else {
          item.fut_contado = 0;
        }
        item.cambio = true;
      });
    }

    if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaPorcentaje") {
      const _precioVentaListaPorcentajeValor = parseFloat(
        valoresData.precioVentaListaPorcentajeValor,
      );

      if (_precioVentaListaPorcentajeValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACPrecioVentaListaPorcentaje.id === "suma") {
            item.precio_venta_lista +=
              (item.precio_venta_lista * _precioVentaListaPorcentajeValor) /
              100;
          } else {
            item.precio_venta_lista -=
              (item.precio_venta_lista * _precioVentaListaPorcentajeValor) /
              100;
          }

          if (item.costo_real > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_lista =
              item.precio_venta_lista / _tasaIva / item.costo_real;
          } else {
            item.fut_lista = 0;
          }
          item.cambio = true;
        });
      }
    } else if (tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaMonto") {
      const _precioVentaListaMontoValor = parseFloat(
        valoresData.precioVentaListaMontoValor,
      );

      if (_precioVentaListaMontoValor > 0) {
        _rangosCambiar.forEach((item) => {
          if (valueACPrecioVentaListaMonto.id === "suma") {
            item.precio_venta_lista += _precioVentaListaMontoValor;
          } else {
            item.precio_venta_lista -= _precioVentaListaMontoValor;
          }

          if (item.costo_real > 0) {
            const _tasaIva = 1 + item.tasa_iva / 100;
            item.fut_lista =
              item.precio_venta_lista / _tasaIva / item.costo_real;
          } else {
            item.fut_lista = 0;
          }
          item.cambio = true;
        });
      }
    } else if (
      tipoPrecioVentaListaRadioState === "tipoPrecioVentaListaFijarPeso"
    ) {
      const _precioVentaListaValorFijarPeso = parseFloat(
        valoresData.precioVentaListaValorFijarPeso,
      );

      _rangosCambiar.forEach((item) => {
        item.precio_venta_lista = _precioVentaListaValorFijarPeso;

        if (item.costo_real > 0) {
          const _tasaIva = 1 + item.tasa_iva / 100;
          item.fut_lista =
            item.precio_venta_lista / _tasaIva / item.costo_real;
        } else {
          item.fut_lista = 0;
        }
        item.cambio = true;
      });
    }
  };
  //
  // ##########################################################################
  //
  const handleCalcularCambios = () => {

    if (expandedAccordion === "costoActual") {
      calculaCostoActual();
    } else if (expandedAccordion === "factorUtilidad") {
      calculaFactorUtilidad();
    } else if (expandedAccordion === "precioVenta") {
      calculaPrecioVenta();
    }

    const _hayValoresInvalidos = hayValoresInvalidos();
    setDisabledAplicarCambios(_hayValoresInvalidos);

    if (_hayValoresInvalidos) {
      setMessage({
        messageText:
          "Los cambios aplicados generaron valores negativos o nulos",
        severity: "error",
      });
      setShowMessage(true);
    }
    setTabIndex(1);
  };
  //
  // ##########################################################################
  //
  const aplicarCambios = async () => {

    let _rangosCambiar = rangosCambiar.map((item) => ({
      id_cr_lprecio_rango: item.id_cr_lprecio_rango,
      costo_pesos: parseFloat(item.costo_pesos),
      costo_dolares: parseFloat(item.costo_dolares),
      valor_dolar: parseFloat(item.valor_dolar),
      porcentaje_descuento: parseFloat(item.porcentaje_descuento),
      costo_real: parseFloat(item.costo_real),
      fut_contado: parseFloat(item.fut_contado),
      precio_venta_contado: parseFloat(item.precio_venta_contado),
      fut_lista: parseFloat(item.fut_lista),
      precio_venta_lista: parseFloat(item.precio_venta_lista),
    }));

    setIsDoingSomething(true);
    const response = await saveCristalValor(_rangosCambiar);
    setIsDoingSomething(false);

    if (response.ok) {
      handleLimpiar();
      setTabIndex(0);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const hayValoresInvalidos = () => {
    const _valorInvalido = rangosCambiar.some((item) => {
      return (
        item.costo_pesos <= 0 ||
        item.costo_dolares <= 0 ||
        item.costo_real <= 0 ||
        item.precio_venta_contado <= 0 ||
        item.precio_venta_lista <= 0
      );
    });
    return _valorInvalido;
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1}>
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box
                  sx={{ mt: 1 }}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h5" display="cristal" gutterBottom>
                    {nameItemsText}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "success.main",
                      opacity: 0.85,
                    }}
                  >
                    Valor del dólar: $ {valorDolar}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              sx={{ mb: 3 }}
            >
              <Tab label="Buscar" size="medium" sx={{ ml: 2 }} />

              <Tab
                label="Resultado"
                size="medium"
                sx={{ ml: 1 }}
                disabled={tabActive === false}
              />

              <Tab
                label="Opciones"
                size="medium"
                sx={{ ml: 1 }}
                disabled={
                  tabOptionsActive === false || rangosCambiar.length === 0
                }
              />
            </Tabs>

            {/* tab buscar */}

            {tabIndex === 0 && (
              <>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-proveedor"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACProveedor && valueACProveedor.id
                          ? valueACProveedor
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACProveedor(newValue);
                        setValoresData({
                          ...valoresData,
                          idProveedor: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACProveedor}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACProveedor(newInputValue);
                      }}
                      options={proveedores}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Proveedor" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-cristal-producto"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACCristalProducto && valueACCristalProducto.id
                          ? valueACCristalProducto
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACCristalProducto(newValue);
                        setValoresData({
                          ...valoresData,
                          idCristalProducto: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACCristalProducto}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACCristalProducto(newInputValue);
                      }}
                      options={cristalProductos}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Producto" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-bl-cr-diametro"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACBlCrDiametro && valueACBlCrDiametro.id
                          ? valueACBlCrDiametro
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACBlCrDiametro(newValue);
                        setValoresData({
                          ...valoresData,
                          idBlCrDiametro: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACBlCrDiametro}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACBlCrDiametro(newInputValue);
                      }}
                      options={blCrDiametros}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Diámetro" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-adicion-desde"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACBlCrAdicionDesde && valueACBlCrAdicionDesde.id
                          ? valueACBlCrAdicionDesde
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACBlCrAdicionDesde(newValue);
                        setValoresData({
                          ...valoresData,
                          idBlCrAdicionDesde: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACBlCrAdicionDesde}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACBlCrAdicionDesde(newInputValue);
                      }}
                      options={blCrAdiciones}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Adición Desde" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <Autocomplete
                      id="id-adicion-hasta"
                      size="small"
                      sx={{ width: "100%" }}
                      value={
                        valueACBlCrAdicionHasta && valueACBlCrAdicionHasta.id
                          ? valueACBlCrAdicionHasta
                          : null
                      }
                      onChange={(event, newValue) => {
                        setValueACBlCrAdicionHasta(newValue);
                        setValoresData({
                          ...valoresData,
                          idBlCrAdicionHasta: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputValueACBlCrAdicionHasta}
                      onInputChange={(event, newInputValue) => {
                        setInputValueACBlCrAdicionHasta(newInputValue);
                      }}
                      options={blCrAdiciones}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Adición Hasta" />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                      disableClearable={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="esferaDesde"
                      label="Esfera Desde"
                      variant="outlined"
                      size="small"
                      name="esferaDesde"
                      type="text"
                      value={valoresData.esferaDesde}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="esferaHasta"
                      label="Esfera Hasta"
                      variant="outlined"
                      size="small"
                      name="esferaHasta"
                      type="text"
                      value={valoresData.esferaHasta}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="cilindroDesde"
                      label="Cilindro Desde"
                      variant="outlined"
                      size="small"
                      name="cilindroDesde"
                      type="text"
                      value={valoresData.cilindroDesde}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="cilindroHasta"
                      label="Cilindro Hasta"
                      variant="outlined"
                      size="small"
                      name="cilindroHasta"
                      type="text"
                      value={valoresData.cilindroHasta}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="costoRealDesde"
                      label="Costo Real Desde"
                      variant="outlined"
                      size="small"
                      name="costoRealDesde"
                      type="text"
                      value={valoresData.costoRealDesde}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      id="costoRealHasta"
                      label="Costo Actual Hasta"
                      variant="outlined"
                      size="small"
                      name="costoRealHasta"
                      type="text"
                      value={valoresData.costoRealHasta}
                      onChange={handleChangeNumber}
                      inputMode="numeric"
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaCostoRealDesde"
                      label="Desde Fecha"
                      name="fechaCostoRealDesde"
                      value={valoresData.fechaCostoRealDesde}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaCostoRealDesde) =>
                        handleChangeFechaDesde(fechaCostoRealDesde)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <DatePicker
                      id="fechaCostoRealHasta"
                      label="Hasta Fecha"
                      name="fechaCostoRealHasta"
                      value={valoresData.fechaCostoRealHasta}
                      format="dd/MM/yyyy"
                      maxDate={new Date()}
                      onChange={(fechaCostoRealHasta) =>
                        handleChangeFechaHasta(fechaCostoRealHasta)
                      }
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          size: "small",
                          variant: "outlined",
                          sx: { width: "100%" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="lista-referencia-select-label">
                        Listas de Referencia
                      </InputLabel>
                      <Select
                        sx={{ width: "100%", mr: 1 }}
                        labelId="listaDeReferencia-select-label"
                        label="Listas de Referencia"
                        id="listaDeReferencia"
                        name="listaDeReferencia"
                        value={valoresData.listaDeReferencia}
                        size="small"
                        onChange={handleChange}
                      >
                        {listaDeReferenciaOptions.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", py: 1 }}
                  >
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>

                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                    >
                      Limpiar
                    </Button>
                  </Box>
                </Grid>
              </>
            )}

            {/* tab resultados */}

            {tabIndex === 1 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    py: 1,
                    px: 1,
                  }}
                >
                  <Typography
                    sx={{ color: "primary.main", fontWeight: "bold" }}
                    variant="body2"
                  >
                    Total de Rangos de Cristales: {rangos.length} - Rangos de
                    Cristales a actualizar: {selectedRows.length}
                  </Typography>

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setOpenConfirmDialog(true)}
                    disabled={disabledAplicarCambios}
                  >
                    Aplicar cambios
                  </Button>
                </Box>

                <DataGrid
                  rows={rangos}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </>
            )}

            {/* tab opciones */}

            {tabIndex === 2 && (
              <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
                {/* Costo Actual */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "costoActual"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "costoActual"
                        ? null
                        : "costoActual",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ marginLeft: 2 }} variant="subtitle2">
                      Costo Actual
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <FormControl>
                          <RadioGroup
                            name="tipo"
                            value={valoresData.tipo}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACCostoPorcentaje?.id
                                    ? valueACCostoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACCostoPorcentaje(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idCostoPorcentaje: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACCostoPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACCostoPorcentaje(newInputValue);
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  valoresData.tipo !== "tipoCostoPorcentaje"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="costoPorcentajeValor"
                                label="Porcentaje"
                                variant="outlined"
                                name="costoPorcentajeValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.costoPorcentajeValor}
                                onChange={handleChange}
                                disabled={
                                  valoresData.tipo !== "tipoCostoPorcentaje" ||
                                  valueACCostoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />
                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACCostoMonto?.id
                                    ? valueACCostoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setvalueACCostoMonto(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idCostoMonto: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACCostoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACCostoMonto(newInputValue);
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={tipoRadioState !== "tipoCostoMonto"}
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="costoMontoValor"
                                label="Monto en $"
                                variant="outlined"
                                name="costoMontoValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.costoMontoValor}
                                onChange={handleChange}
                                disabled={
                                  tipoRadioState !== "tipoCostoMonto" ||
                                  valueACCostoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={2}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="costoValorFijarPeso"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="costoValorFijarPeso"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={valoresData.costoValorFijarPeso}
                                  onChange={handleChange}
                                  disabled={
                                    tipoRadioState !== "tipoCostoFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>

                            {/* FIJAR EN DOLAR */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoFijarDolar"
                                control={<Radio size="small" />}
                                label="Fijar en U$S"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={2}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="costoValorFijarDolar"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="costoValorFijarDolar"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={valoresData.costoValorFijarDolar}
                                  onChange={handleChange}
                                  disabled={
                                    tipoRadioState !== "tipoCostoFijarDolar"
                                  }
                                />
                              </Grid>
                            </Box>

                            {/* FIJAR % de Descuento */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoCostoFijarDescuento"
                                control={<Radio size="small" />}
                                label="Descuento"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={2}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="costoDescuentoValor"
                                  label="% de Descuento"
                                  variant="outlined"
                                  name="costoDescuentoValor"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={valoresData.costoDescuentoValor}
                                  onChange={handleChange}
                                  disabled={
                                    tipoRadioState !== "tipoCostoFijarDescuento"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Factor de Utilidad */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "factorUtilidad"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "factorUtilidad" ? null : "factorUtilidad",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ marginLeft: 2 }} variant="subtitle2">
                      Factor de Utilidad
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Contado
                          </Typography>

                          <RadioGroup
                            name="tipoFactorContado"
                            value={valoresData.tipoFactorContado}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorContadoPorcentaje?.id
                                    ? valueACFactorContadoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorContadoPorcentaje(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idFactorContadoPorcentaje: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACFactorContadoPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorContadoPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoPorcentaje"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="factorContadoPorcentajeValor"
                                label="Porcentaje"
                                variant="outlined"
                                name="factorContadoPorcentajeValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.factorContadoPorcentajeValor}
                                onChange={handleChange}
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoPorcentaje" ||
                                  valueACFactorContadoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoMonto"
                                control={<Radio size="small" />}
                                label="Valor"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorContadoMonto?.id
                                    ? valueACFactorContadoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorContadoMonto(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idFactorContadoMonto: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACFactorContadoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorContadoMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoMonto"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="factorContadoMontoValor"
                                label="Valor"
                                variant="outlined"
                                name="factorContadoMontoValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.factorContadoMontoValor}
                                onChange={handleChange}
                                disabled={
                                  tipoFactorContadoRadioState !==
                                  "tipoFactorContadoMonto" ||
                                  valueACFactorContadoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorContadoFijarValor"
                                control={<Radio size="small" />}
                                label="Fijar en"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="factorContadoValorFijarPeso"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="factorContadoValorFijarPeso"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    valoresData.factorContadoValorFijarPeso
                                  }
                                  onChange={handleChange}
                                  disabled={
                                    tipoFactorContadoRadioState !==
                                    "tipoFactorContadoFijarValor"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Lista
                          </Typography>

                          <RadioGroup
                            name="tipoFactorLista"
                            value={valoresData.tipoFactorLista}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorListaPorcentaje?.id
                                    ? valueACFactorListaPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorListaPorcentaje(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idFactorListaPorcentaje: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACFactorListaPorcentaje}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorListaPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaPorcentaje"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="factorListaPorcentajeValor"
                                label="Porcentaje"
                                variant="outlined"
                                name="factorListaPorcentajeValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.factorListaPorcentajeValor}
                                onChange={handleChange}
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaPorcentaje" ||
                                  valueACFactorListaPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaMonto"
                                control={<Radio size="small" />}
                                label="Valor"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACFactorListaMonto?.id
                                    ? valueACFactorListaMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACFactorListaMonto(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idFactorListaMonto: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACFactorListaMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACFactorListaMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaMonto"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="factorListaMontoValor"
                                label="Valor"
                                variant="outlined"
                                name="factorListaMontoValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.factorListaMontoValor}
                                onChange={handleChange}
                                disabled={
                                  tipoFactorListaRadioState !==
                                  "tipoFactorListaMonto" ||
                                  valueACFactorListaMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoFactorListaFijarValor"
                                control={<Radio size="small" />}
                                label="Fijar en"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="factorListaValorFijarPeso"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="factorListaValorFijarPeso"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={valoresData.factorListaValorFijarPeso}
                                  onChange={handleChange}
                                  disabled={
                                    tipoFactorListaRadioState !==
                                    "tipoFactorListaFijarValor"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Precio de Venta */}

                <Accordion
                  sx={{ border: "1px solid lightgray" }}
                  expanded={expandedAccordion === "precioVenta"}
                  onChange={() =>
                    setExpandedAccordion(
                      expandedAccordion === "precioVenta"
                        ? null
                        : "precioVenta",
                    )
                  }
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ marginLeft: 2 }} variant="subtitle2">
                      Precio de Venta
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Contado
                          </Typography>

                          <RadioGroup
                            name="tipoPrecioVentaContado"
                            value={valoresData.tipoPrecioVentaContado}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaContadoPorcentaje?.id
                                    ? valueACPrecioVentaContadoPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaContadoPorcentaje(
                                    newValue,
                                  );
                                  setRangoData({
                                    ...rangoData,
                                    idPrecioVentaContadoPorcentaje: newValue.id,
                                  });
                                }}
                                inputValue={
                                  inputValueACPrecioVentaContadoPorcentaje
                                }
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaContadoPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoPorcentaje"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="precioVentaContadoPorcentajeValor"
                                label="Porcentaje"
                                variant="outlined"
                                name="precioVentaContadoPorcentajeValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  valoresData.precioVentaContadoPorcentajeValor
                                }
                                onChange={handleChange}
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoPorcentaje" ||
                                  valueACPrecioVentaContadoPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaContadoMonto?.id
                                    ? valueACPrecioVentaContadoMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaContadoMonto(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idPrecioVentaContadoMonto: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACPrecioVentaContadoMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaContadoMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoMonto"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="precioVentaContadoMontoValor"
                                label="Monto en $"
                                variant="outlined"
                                name="precioVentaContadoMontoValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.precioVentaContadoMontoValor}
                                onChange={handleChange}
                                disabled={
                                  tipoPrecioVentaContadoRadioState !==
                                  "tipoPrecioVentaContadoMonto" ||
                                  valueACPrecioVentaContadoMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaContadoFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="precioVentaContadoValorFijarPeso"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="precioVentaContadoValorFijarPeso"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    valoresData.precioVentaContadoValorFijarPeso
                                  }
                                  onChange={handleChange}
                                  disabled={
                                    tipoPrecioVentaContadoRadioState !==
                                    "tipoPrecioVentaContadoFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl>
                          <Typography variant="h6" sx={{ mb: 1, ml: 1 }}>
                            Lista
                          </Typography>

                          <RadioGroup
                            name="tipoPrecioVentaLista"
                            value={valoresData.tipoPrecioVentaLista}
                            onChange={handleChange}
                          >
                            {/* PORCENTAJE */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaPorcentaje"
                                control={<Radio size="small" />}
                                label="Porcentaje"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaListaPorcentaje?.id
                                    ? valueACPrecioVentaListaPorcentaje
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaListaPorcentaje(
                                    newValue,
                                  );
                                  setRangoData({
                                    ...rangoData,
                                    idPrecioVentaListaPorcentaje: newValue.id,
                                  });
                                }}
                                inputValue={
                                  inputValueACPrecioVentaListaPorcentaje
                                }
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaListaPorcentaje(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaPorcentaje"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="precioVentaListaPorcentajeValor"
                                label="Porcentaje"
                                variant="outlined"
                                name="precioVentaListaPorcentajeValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  valoresData.precioVentaListaPorcentajeValor
                                }
                                onChange={handleChange}
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaPorcentaje" ||
                                  valueACPrecioVentaListaPorcentaje.id === ""
                                }
                              />
                            </Box>

                            {/* MONTO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaMonto"
                                control={<Radio size="small" />}
                                label="Monto en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Autocomplete
                                id="id-suma-resta"
                                size="small"
                                sx={{ minWidth: 200, flex: 1 }}
                                value={
                                  valueACPrecioVentaListaMonto?.id
                                    ? valueACPrecioVentaListaMonto
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  setValueACPrecioVentaListaMonto(newValue);
                                  setRangoData({
                                    ...rangoData,
                                    idPrecioVentaListaMonto: newValue.id,
                                  });
                                }}
                                inputValue={inputValueACPrecioVentaListaMonto}
                                onInputChange={(e, newInputValue) => {
                                  setInputValueACPrecioVentaListaMonto(
                                    newInputValue,
                                  );
                                }}
                                options={sumaRestaOptions}
                                getOptionLabel={(option) => option.descripcion}
                                renderInput={(params) => (
                                  <TextField {...params} label="Suma/Resta" />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                disableClearable
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaMonto"
                                }
                              />

                              <TextField
                                fullWidth
                                sx={{
                                  minWidth: 150,
                                  flex: 1,
                                  "& input[type=number]": {
                                    MozAppearance: "textfield", // Firefox
                                  },
                                  "& input[type=number]::-webkit-outer-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                  "& input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0,
                                  },
                                }}
                                size="small"
                                id="precioVentaListaMontoValor"
                                label="Monto en $"
                                variant="outlined"
                                name="precioVentaListaMontoValor"
                                type="number"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={valoresData.precioVentaListaMontoValor}
                                onChange={handleChange}
                                disabled={
                                  tipoPrecioVentaListaRadioState !==
                                  "tipoPrecioVentaListaMonto" ||
                                  valueACPrecioVentaListaMonto.id === ""
                                }
                              />
                            </Box>

                            {/* FIJAR EN PESO */}

                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <FormControlLabel
                                value="tipoPrecioVentaListaFijarPeso"
                                control={<Radio size="small" />}
                                label="Fijar en $"
                                sx={{ minWidth: "120px", mr: 1 }}
                              />

                              <Grid item xs={12} md={12} lg={4.5}>
                                <TextField
                                  fullWidth
                                  sx={{
                                    minWidth: 150,
                                    flex: 1,
                                    "& input[type=number]": {
                                      MozAppearance: "textfield", // Firefox
                                    },
                                    "& input[type=number]::-webkit-outer-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input[type=number]::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  }}
                                  size="small"
                                  id="precioVentaListaValorFijarPeso"
                                  label="Monto en $"
                                  variant="outlined"
                                  name="precioVentaListaValorFijarPeso"
                                  type="number"
                                  pattern="[0-9]*"
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "e" ||
                                      e.key === "-" ||
                                      e.key === "+"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={
                                    valoresData.precioVentaListaValorFijarPeso
                                  }
                                  onChange={handleChange}
                                  disabled={
                                    tipoPrecioVentaListaRadioState !==
                                    "tipoPrecioVentaListaFijarPeso"
                                  }
                                />
                              </Grid>
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {/* Botones FUERA del Accordion */}

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", py: 1 }}
                  >
                    <Button
                      variant="contained"
                      color="info"
                      startIcon={<CalculateIcon />}
                      onClick={handleCalcularCambios}
                    >
                      Calcular cambios
                    </Button>
                  </Box>
                </Grid>
              </Paper>
            )}
          </Box>
        </Paper>
      </Paper>

      {openDialog && (
        <ValorCristalDialog
          onClose={handleDialogClose}
          rangoData={rangoData}
        />
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>Confirmar aplicación de cambios</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Confirmás que querés aplicar los cambios? Esta acción no se puede
            deshacer
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmDialog(false);
              aplicarCambios();
            }}
            color="primary"
            variant="contained"
            sx={{
              mt: 1,
              mb: 1,
            }}
          >
            Confirmar
          </Button>

          <Button
            onClick={() => setOpenConfirmDialog(false)}
            variant="outlined"
            sx={{
              mr: 2,
              mt: 1,
              mb: 1,
            }}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ValorCristalTable;
